import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import AccountSettings from 'components/settings/account-settings';
import VerificationSettings from 'components/settings/verification-settings';
import DashboardWrapperLayout from 'layouts/dashboard-wrapper';
import { Flex } from '@chakra-ui/react';

const Settings = () => {
  // STATES
  // Set up tabs for page state
  // Set up url query params for activeTab
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTabFromUrl = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState(activeTabFromUrl || 'account');

  // keep URL in sync with active tab
  useEffect(() => {
    // merge only the 'tab' param, preserving others, avoid flicker on identical value
    if (searchParams.get('tab') !== activeTab) {
      const params = new URLSearchParams(searchParams);
      params.set('tab', activeTab);
      setSearchParams(params, { replace: true });
    }
  }, [activeTab, searchParams, setSearchParams]);

  const tabs = [
    {
      title: 'My Account',
      selected: activeTab === 'account',
      onClick: () => {
        setActiveTab('account');
      },
    },
    {
      title: 'Verification',
      selected: activeTab === 'verification',
      onClick: () => {
        setActiveTab('verification');
      },
    },
  ];

  return (
    <DashboardWrapperLayout 
      title='Settings'
      tabs={tabs}
    >
      <Flex className='flex flex-col w-full gap-12'>
        {/* Content */}
        {activeTab === 'account' ? (
          <AccountSettings />
        ) : activeTab === 'verification' ? (
          <VerificationSettings />
        ) : null}
      </Flex>
    </DashboardWrapperLayout>
  );
};

export default Settings;
